import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { callApi, fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)

interface popupProps {
  rowData?: any;
  modalRef?: any;
}

const SN_PRD_BAS_REP_003_POP_01 = forwardRef(
  ({ rowData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
      grid1: React.createRef<SnGridRef>(),
    });

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };
    const searchRef = useRef<any>(null);
    const { userInfo } = global(); // Login user 정보
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });
    //#endregion

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_PRD_BAS_REP_003_POP_01", {});
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(rtn.formData); // 조회조건 초기값
          setColums({ grid1: rtn.grid.grid1 }); // H그리드 항목 설정
          setDataSources({ grid1: rowData });
          setTimeout(() => {
            gridRefs.current["grid1"]?.current?.selectAllFiltered();
          }, 50);
        } catch (error) {}
      };
      fetchform();
    }, []);

    //#region Button Event
    const ChangeItem = async () => {
      const panelData = searchRef.current.getFormdata();
      let cd_matl = panelData.cd_item;
      if (cd_matl === "") {
        await showDialog("alter", "변경 품목을 선택하시기 바랍니다.");
        return;
      }

      const confirm = await showDialog(
        "confirmCancel",
        "일괄 변경하시겠습니까?"
      );
      if (!confirm) return;

      const selectedRows = getGridCurrent("grid1").getCheckedRows();
      let cd_item,
        nm_item,
        cd_child: string = "";
      for (const node of selectedRows) {
        cd_item = node?.cd_parent;
        nm_item = node?.nm_item;
        cd_child = node?.cd_child;

        if (cd_item === cd_matl) {
          await showDialog(
            "alter",
            `${cd_item}(${nm_item}) 모품목과 동일한 품목을 자품목으로 등록할 수 없습니다.`
          );
          return;
        }

        if ((node?.no_rev ?? "") !== "" || (node?.no_req ?? null) !== null) {
          await showDialog(
            "alter",
            `${cd_item}(${nm_item})은 개정관리 품목입니다.`
          );
          return;
        }
      }
      const queries = selectedRows.map((row: any) => {
        const cd_item = row?.cd_parent;
        const cd_child = row?.cd_child;

        return `
          UPDATE PRD_BOML SET cd_matl = '${cd_matl}' WHERE cd_firm = '${userInfo.cd_firm}' AND cd_biz = '${userInfo.cd_biz}' AND cd_item = '${cd_item}' AND cd_matl = '${cd_child}';`.trim();
      });

      const updateResult = await callApi(
        "SN_PRD_BAS_REP_003_UPDATEITEM",
        queries
      );
      if (updateResult.status === true) {
        await showDialog("success", "변경되었습니다.");
        modalRef.current?.handleConfirm?.(true, { success: true, cd_matl });
        return { success: true, cd_matl };
      }
    };
    //#endregion

    //#region Event Method
    //#endregion

    //#region useMemo
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
        },
      }),
      [columns, dataSources]
    );
    //#endregion

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"확인"}
            onClick={ChangeItem}
            sx={{
              width: 80,
              marginTop: 1.5,
            }}
            spinner={true}
          />
        </div>
        <div>
          <div style={{ height: "50vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs.current["grid1"]} // Grid Name
              columnConfig={grids.grid1.columns} // 컬럼 설정 전달
              rowData={grids.grid1.dataSource} // Datasource
              etcProps={{
                rowSelection: "multiple",
                title: "",
                isEditable: false,
                ischeckboxSelection: true,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_PRD_BAS_REP_003_POP_01;
